import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError('');
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const demoAccounts = [
    { label: 'Chief Engineer', user: 'ce_wilson', pass: 'password123' },
    { label: 'Fleet Superintendent', user: 'supt_kim', pass: 'password123' },
    { label: 'Procurement Officer', user: 'proc_tan', pass: 'password123' },
    { label: 'Shore Admin', user: 'admin_chang', pass: 'password123' },
  ];

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Logo */}
        <div className="login-logo">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="iSHIP+ Logo" style={{ height: 52, marginBottom: 12, objectFit: 'contain' }} />
          <p style={{ fontSize: 11, color: '#85A3C1', textTransform: 'uppercase', letterSpacing: 1.5, marginTop: 4 }}>
            Planned Maintenance System
          </p>
          <p style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>by iSHIP Solutions Pte. Ltd.</p>
        </div>

        {error && (
          <div className="alert alert-danger" style={{ marginBottom: 16 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              className="form-input"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="username"
              style={{ fontSize: 14 }}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                className="form-input"
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
                style={{ paddingRight: 44, fontSize: 14 }}
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                style={{
                  position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)', padding: 0,
                }}
              >
                {showPass ? <EyeOff size={17} /> : <Eye size={17} />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '11px', fontSize: 14, fontWeight: 600, letterSpacing: 0.3 }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} />
                Signing in...
              </>
            ) : 'Sign In'}
          </button>
        </form>

        {/* Demo accounts */}
        <div style={{ marginTop: 28, paddingTop: 20, borderTop: '1px solid var(--border)' }}>
          <p style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 10, textAlign: 'center', letterSpacing: 0.5 }}>
            QUICK ACCESS — DEMO ACCOUNTS
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {demoAccounts.map(acc => (
              <div
                key={acc.user}
                onClick={() => { setUsername(acc.user); setPassword(acc.pass); }}
                style={{
                  background: '#f4f6f9',
                  border: '1px solid var(--border)',
                  borderRadius: 8,
                  padding: '9px 11px',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#3B6082'; e.currentTarget.style.background = '#EBF3F9'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = '#f4f6f9'; }}
              >
                <div style={{ fontWeight: 600, fontSize: 11, color: 'var(--text)' }}>{acc.label}</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: 11, marginTop: 1 }}>{acc.user}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
